import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { Redirect, useRouteMatch } from "react-router-dom";
import { NAV_ITEMS } from "../../utilities/index.js";

const HelpSection = ({ url }) => {
  const { path } = useRouteMatch();
  useEffect(() => {
    window.open(url);
  }, []);

  const dashboardURL = NAV_ITEMS.filter((item) => item.id === "dashboard")[0];

  return <Redirect push from={path} to={`/${dashboardURL.url}`} />;
};

HelpSection.propTypes = {
  url: PropTypes.string.isRequired,
};
HelpSection.defaultProps = {
  url:
    "https://gcc-punchout.s3.amazonaws.com/Vendor+Portal/Help+Link/GCC-VendorPortal_Help.pdf",
};

export default HelpSection;
